<template>
  <div class="result-class">
    <img v-if="resultData.landingImage" :src="resultData.landingImage" alt="img" />
    <CheckCircleFilled v-else class="result-class-icon" />
    <div class="result-class-tips">
      {{ resultData.landingText ? resultData.landingText : $t('ep_admin_form_result_tip2') }}
    </div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps({
  resultData: {
    type: Object,
    required: true,
    default: () => ({})
  }
})
</script>

<style lang="less" scoped>
.result-class {
  padding-top: 25vh;
  text-align: center;
  img {
    max-width: 500px;
  }
}
.result-class-icon {
  font-size: 60px;
  color: rgb(2, 191, 15);
}
.result-class-tips {
  font-size: 16px;
  margin-top: 20px;
  line-height: 20px;
}
</style>
